import { useAuthContext } from '@providers/AuthProvider';
import { Helmet } from 'react-helmet-async';
import { Content } from './components/Content';
import { PageProvider } from './providers/PageProvider';

export const JobsListPage = () => {
  const { organization, workspace } = useAuthContext();

  if (!organization || !workspace) {
    return null;
  }

  return (
    <>
      <Helmet>
        <title>Jobs List - AutoScript</title>
      </Helmet>

      <PageProvider workspaceId={workspace.id}>
        <Content />
      </PageProvider>
    </>
  );
};
